import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const createAccount = async ({ email, password, displayName }) => {
    try {
        // Create the user with email and password
        const userCredential = await firebase.auth().createUserWithEmailAndPassword(email, password);
        
        if (userCredential) {
            const user = userCredential.user;

            // Update the user's profile with displayName
            await user.updateProfile({
                displayName: displayName,
            });

            const { email, uid } = user;

            console.log(`New user is created with Email: ${email}, UID: ${uid}`);

            // Return the UID and displayName
            return { uid, displayName, email };
        } else {
            alert("Something went wrong during account creation");
            return null; // Return null if userCredential is not valid
        }
    } catch (error) {
        const errorCode = error.code;
        const errorMessage = error.message;

        // Handle specific errors
        if (errorCode === 'auth/invalid-email') {
            alert('Error: The email address is not valid.');
        } else if (errorCode === 'auth/email-already-in-use') {
            alert('Error: The email address is already in use by another account.');
        } else {
            console.error('Error creating user:', errorCode, errorMessage);
        }

        return null; // Return null if an error occurs
    }
};

export { createAccount };
